import * as React from 'react';

import { Adfox } from '../adfox/adfox';
import { adfoxMediaConstants } from '../adfox/constants';
import { MediaBanner } from '../media_banner/media_banner';

import { IAdFoxBannerContext } from '@cian/adfox';
import { AB_ALLOWED_SEARCH_TYPES, AB_ALLOWED_SECTIONS } from '../../helpers/ab_newbuilding_search_tabs';

const s = require('./filters_block.css');

const backgrounds: IBackgrounds = {
  index: s['c-filters-bg_home'],
  'daily-rent': s['c-filters-bg_daily-rent'],
  commercial: s['c-filters-bg_commercial'],
  sale: s['c-filters-bg_sale'],
  rent: s['c-filters-bg_rent'],
  'new-buildings': s['c-filters-bg_new-buildings'],
};

export interface IBackgrounds {
  [Identifier: string]: string;
}

interface IProps {
  section: string;
  backgroundImageUrl?: string;
  backgroundShown: boolean;
  onLoadAdfox?: (context: IAdFoxBannerContext) => void;
  mediaInfoText?: string;
  mediaNote?: string;
  isExperimentsLoading: boolean;
  abNewbuildingSearchTabs: boolean;
  selectedType: string;
}

interface IState {
  defaultImageUrl: string;
}

export class FiltersBlock extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);
    this.state = { defaultImageUrl: backgrounds[props.section] };
  }

  public render() {
    const needAbNewbuildingSearchTabsClass = (
      this.props.abNewbuildingSearchTabs &&
      AB_ALLOWED_SEARCH_TYPES.includes(this.props.selectedType) &&
      AB_ALLOWED_SECTIONS.includes(this.props.section)
    ) ? s['c-filters-newbuilding-ab'] : '';

    return (
      <div className={`${s['c-filters']}
                        ${this.props.backgroundShown ?
                          '' :
                          s['c-filters-transparent']}
                          ${needAbNewbuildingSearchTabsClass}`}>
        <div className={s['c-filters-content']}>
          <div className={s['c-filters-inner']}>
            { this.props.children }
            <div className={s['c-filters-text']}>{this.props.mediaNote}</div>
          </div>
          {
            !this.props.isExperimentsLoading &&
              <Adfox
                constants={adfoxMediaConstants}
                section={this.props.section}
                banner={(context: IAdFoxBannerContext) => (
                    <MediaBanner
                      {...context}
                      infoText={this.props.mediaInfoText}
                      onDidMount={() => this.props.onLoadAdfox && this.props.onLoadAdfox(context)}
                    />
                  )
                }
                failureBanner={(error: Error) => (
                    <MediaBanner
                      infoText={this.props.mediaInfoText}
                      onDidMount={() => this.props.onLoadAdfox && this.props.onLoadAdfox({
                        newBuildingId: '',
                        isApartment: '',
                      })}
                    />
                  )
                }
              />
          }
        </div>
        <div className={s['c-filters-content-overlay']}></div>
        <div
          className={`${s['c-filters-bg']} ${this.state.defaultImageUrl}`}
          style={{backgroundImage: this.props.backgroundImageUrl ?
                            `url(${this.props.backgroundImageUrl})` :
                            ``,
        }}/>
      </div>
    );
  }
}
